import React from "react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

const groups = [
  { key: "status", label: "Invoice status", options: [["outstanding", "Outstanding"], ["all", "All invoices"]] },
  { key: "type", label: "Invoice type", options: [["all", "All"], ["regular", "Regular"], ["payroll", "Payroll"]] },
];

export const ColonyInvoiceFilters = ({ status, type, onStatusChange, onTypeChange }) => (
  <>
    {groups.map(group => (
      <ToggleGroup
        key={group.key}
        type="single"
        size="sm"
        value={group.key === "status" ? status : type}
        onValueChange={value => { if (value) (group.key === "status" ? onStatusChange : onTypeChange)(value); }}
        aria-label={group.label}
        className={`colony-invoice-filter-${group.key} gap-1`}
        data-testid={`colony-invoice-${group.key}-filters`}
      >
        {group.options.map(([value, label]) => (
          <ToggleGroupItem
            key={value}
            value={value}
            className="h-6 min-w-0 rounded-sm border border-border bg-transparent px-1.5 text-[10px] font-medium uppercase transition-colors hover:bg-emerald-50 data-[state=on]:border-emerald-200 data-[state=on]:bg-emerald-100 data-[state=on]:text-emerald-900"
            data-testid={`colony-invoice-${group.key}-${value}`}
          >
            {label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    ))}
  </>
);